"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AriForm_1 = require("./AriForm");
const Webform_1 = __importDefault(require("./Webform"));
const utils_1 = require("./utils/utils");
const AriFormUtils = __importStar(require("./utils/utils"));
const sweetalert_1 = __importDefault(require("sweetalert"));
class PDF extends Webform_1.default {
    constructor(element, options) {
        options.display = 'pdf';
        super(element, options);
        this.components = [];
        this.otpInfo = {};
        this.handleClickSubmit = null;
        this.hanldeclickCloseOTP = null;
        this.listeners = {};
        this.otpInputs = ['otp1', 'otp2', 'otp3', 'otp4', 'otp5', 'otp6'];
        this.countdownTime = 0;
        this.countdownEl = null;
        this.interval = null;
        this.resendEvent = null;
        this.bsModal = null;
        this.authenKey = null;
        this.authenType = null;
        this.biometricData = null;
    }
    init() {
        super.init();
        // Handle an iframe submission.
        this.on('iframe-submission', (submission) => this.setValue(submission, {
            fromIframe: true
        }), true);
        this.on('iframe-change', (submission) => this.setValue(submission, {
            fromIframe: true
        }), true);
        this.on('iframe-getIframePositions', (query) => {
            const iframe = document.getElementById(`iframe-${query.formId}`);
            if (iframe) {
                const iframeBoundingClientRect = iframe.getBoundingClientRect();
                this.postMessage({
                    name: 'iframePositions',
                    data: {
                        formId: query.formId,
                        iframe: {
                            top: iframeBoundingClientRect.top
                        },
                        scrollY: window.scrollY || window.pageYOffset
                    }
                });
            }
        });
        // Trigger when this form is ready.
        this.on('iframe-ready', () => this.iframeReadyResolve(), true);
    }
    renderOtpCode() {
        return `<div class="modal fade show" id="otp-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered ari-w-[90%] ari-max-w-[90%] sm:ari-max-w-[400px] ari-m-auto">
    <div class="modal-content">
    <div class="modal-header-custom">
         <div class="logo-verify-code"></div>
      <div class="ari-text-center otp-info-title ari-my-4 ari-w-full">
      <h1 class="m-auto ari-mt-4 ari-font-semibold ari-text-lg ari-text-gray-900 ari-text-center ">${AriFormUtils.getLangText("OTP Verification")}</h1>
        <p class=" m-auto ari-mt-1 ari-text-sm ari-text-gray-600 ari-max-w-xs ari-text-center">
       ${AriFormUtils.getLangText("We've sent verification code to")} ${this.otpInfo.authenType === 'SMSOTP' ? AriFormUtils.getLangText("phone number") : AriFormUtils.getLangText("email")}
        <span class="ari-font-semibold d-block ari-text-[18px]">${this.otpInfo.ctmPhoneNoOrEmail || ''}</span>
      </p>
      </div>
        <button type="button" class="close-modal-otp ari-text-[#01539f] ari-absolute ari-top-0 ari-right-0 ari-w-[25px] ari-h-[25px] ari-rounded-full ari-flex ari-justify-center ari-items-center ari-text-[25px]" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body ">
  <label class="ari-block ari-text-gray-700 ari-font-medium ari-mb-2" for="otp">
    ${AriFormUtils.getLangText("Verification Code")}
  </label>
        <div class="ari-m-auto">
          <div class="ari-flex ari-justify-between ari-mb-6">
            <input aria-label="OTP digit 1"
              class=" ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
              inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
               id="otp1" />
            <input aria-label="OTP digit 2"
              class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
              inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
               id="otp2" />
            <input aria-label="OTP digit 3"
              class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
              inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
               id="otp3" />
            <input aria-label="OTP digit 4"
              class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
              inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
               id="otp4" />
            <input aria-label="OTP digit 5"
              class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
              inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text"
               id="otp5" />
            <input aria-label="OTP digit 6"
              class="ari-w-10 ari-h-10 sm:ari-w-10 sm:ari-h-10 ari-border ari-border-gray-300 ari-rounded-lg ari-text-center ari-text-lg ari-font-semibold ari-text-gray-900 ari-focus:ari-outline-none ari-focus:ari-ring-2 ari-focus:ari-ring-blue-400"
              inputmode="numeric" maxlength="1" pattern="[0-9]*" type="text" id="otp6"/>
          </div>
          <div class="ari-flex ari-justify-center ari-gap-2 ari-items-center ari-mt-2">
            <button type="button" disabled class="btn btn btn-primary btn-md btn-block custom-ib-btn loader-size ari-w-full bpm-do-task-pdf">${AriFormUtils.getLangText("Submit")}</button>
          </div>
          <div class="coundown-wraper ari-text-gray-500 ari-font-medium ari-text-center ari-m-auto ari-mt-2"> </div>
          <div class=" wraper-resend-otp-btn d-none ari-gap-2 ari-items-center  ari-text-sm ari-text-gray-500 ari-font-medium ari-text-center ari-justify-center ari-mt-4">
             <p class="mt-4 text-center text-gray-700 text-sm">${AriFormUtils.getLangText("Didn't receive the code?")}</p>
            <button type="button" class="ari-text-blue-600 ari-mx-auto ari-mt-2 ari-text-center ari-text-sm ari-font-medium  ari-block resend-otp-btn">
            ${AriFormUtils.getLangText("Resend OTP Code")}
          </button>
          </div>
          
        </div>

      </div>
    </div>
  </div>
</div>`;
    }
    render() {
        this.submitButton = this.addComponent({
            disabled: this.form.disableWizardSubmit,
            input: true,
            type: 'button',
            action: 'custom',
            disableOnInvalid: true,
            internal: true,
            label: 'Submit',
            key: 'submit',
            ref: 'button',
            hidden: this.isSubmitButtonHidden()
        });
        return this.renderTemplate('pdf', {
            submitButton: this.submitButton.render(),
            classes: 'ariform-form-pdf',
            children: this.renderComponents()
        });
    }
    redraw() {
        this.postMessage({ name: 'redraw' });
        return this.builderMode ? Promise.resolve() : super.redraw();
    }
    destroy(all = false) {
        if (this.iframeElement) {
            delete this.iframeElement.ariformComponent;
            this.iframeElement.ariformComponent = null;
        }
        super.destroy(all);
    }
    rebuild() {
        if (this.builderMode && this.component.components) {
            this.destroyComponents();
            this.addComponents();
            return Promise.resolve();
        }
        this.postMessage({ name: 'redraw' });
        return super.rebuild();
    }
    // Do not attach nested components for pdf.
    attachComponents(element, components, container) {
        components = components || this.components;
        container = container || this.component.components;
        element = this.hook('attachComponents', element, components, container, this);
        return Promise.resolve();
    }
    // hungnq
    checkOtpComplete() {
        const otp = this.getFullOtpValue();
        const button = document.querySelector(".ari-w-full.bpm-do-task-pdf");
        if (button) {
            button.disabled = otp.length !== 6;
        }
    }
    getFullOtpValue() {
        let otp = '';
        for (let i = 1; i <= 6; i++) {
            const input = document.getElementById(`otp${i}`);
            if (input) {
                otp += input.value;
            }
        }
        return otp;
    }
    handleInput(current, nextFieldID) {
        current.value = current.value.replace(/[^0-9]/g, "");
        if (current.value.length === 1 && nextFieldID) {
            const nextField = document.getElementById(nextFieldID);
            if (nextField) {
                nextField.focus();
            }
        }
        this.checkOtpComplete();
    }
    handleBackspace(event, current, prevFieldID) {
        if (event.key === "Backspace" && current.value === "") {
            if (prevFieldID) {
                const prevField = document.getElementById(prevFieldID);
                if (prevField) {
                    prevField.focus();
                    prevField.value = "";
                    event.preventDefault();
                }
            }
        }
        this.checkOtpComplete();
    }
    initOtpInputs() {
        this.otpInputs.forEach((id, index) => {
            const input = document.getElementById(id);
            // Nếu đã có listener cũ thì gỡ ra
            if (this.listeners[id]) {
                input.removeEventListener("input", this.listeners[id].input);
                input.removeEventListener("keydown", this.listeners[id].keydown);
                input.removeEventListener("paste", this.listeners[id].paste);
            }
            // Tạo các hàm lắng nghe mới
            const inputHandler = () => {
                this.handleInput(input, this.otpInputs[index + 1]);
            };
            const keydownHandler = (event) => {
                this.handleBackspace(event, input, this.otpInputs[index - 1]);
            };
            const pasteHandler = (event) => {
                event.preventDefault();
                const pastedData = event.clipboardData.getData("text").replace(/\D/g, ""); // Chỉ lấy số
                // Dán từ vị trí đầu tiên
                for (let i = 0; i < this.otpInputs.length; i++) {
                    const char = pastedData[i] || "";
                    const targetInput = document.getElementById(this.otpInputs[i]);
                    if (targetInput) {
                        targetInput.value = char;
                    }
                }
                // Focus vào ô tiếp theo hợp lý
                const nextIndex = Math.min(pastedData.length, this.otpInputs.length - 1);
                const nextInput = document.getElementById(this.otpInputs[nextIndex]);
                nextInput === null || nextInput === void 0 ? void 0 : nextInput.focus();
                this.checkOtpComplete();
            };
            // Gán vào DOM
            input.addEventListener("input", inputHandler);
            input.addEventListener("keydown", keydownHandler);
            input.addEventListener("paste", pasteHandler); // ✨ Gắn cho tất cả input
            // Lưu để lần sau có thể gỡ ra
            this.listeners[id] = {
                input: inputHandler,
                keydown: keydownHandler,
                paste: pasteHandler
            };
        });
    }
    updateCountdownDisplay(seconds) {
        const min = Math.floor(seconds / 60);
        const sec = seconds % 60;
        this.countdownEl.textContent =
            `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
    }
    startCountdown() {
        this.updateCountdownDisplay(this.countdownTime); // lần đầu hiển thị
        this.interval = setInterval(() => {
            this.countdownTime--;
            if (this.countdownTime <= 0) {
                clearInterval(this.interval);
                this.countdownEl.classList.add('hidden');
                document.querySelector('.wraper-resend-otp-btn').classList.remove('d-none');
            }
            else {
                this.updateCountdownDisplay(this.countdownTime);
            }
        }, 1000);
    }
    clearInputOTP() {
        for (let i = 0; i < this.otpInputs.length; i++) {
            const targetInput = document.getElementById(this.otpInputs[i]);
            if (targetInput) {
                targetInput.value = "";
            }
        }
    }
    callAPINextStep() {
        const form = this.getRoot();
        const body = {
            "params": {
                "taskId": form.formState.taskId,
            },
            // "tokenInfo": {
            //   "channelId": "MB",
            //   "ctmLicenseNo": null,
            //   "ctmCif": "11000900"
            // }
        };
        const handleSuccessGetNextStep = (result) => {
            AriFormUtils.removeLoadingFullScreen();
            (0, sweetalert_1.default)({
                title: "Submit contract successfully",
                text: "Do you want to continue?",
                icon: "success",
                buttons: true,
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    const urlLink = result.isTaskOfCurrentUser ? `${(AriForm_1.AriForm.encryptUrl === "true" || AriForm_1.AriForm.encryptUrl === true) ? `/ari${AriFormUtils.formatUrl(result.redirectLink)}` : AriFormUtils.formatUrl(result.redirectLink)}` : AriFormUtils.formatUrl(`ctmloandetail?taskId=${form.formState.taskId}`);
                    AriFormUtils.execExternalFunction('redirectUrl', urlLink);
                }
            });
        };
        const handleErrorGetNextStep = (error) => {
            AriFormUtils.removeLoadingFullScreen();
            AriFormUtils.showPopup('error', 'Failed', error);
        };
        AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointGetNextStep}`, 'POST', body, {}, handleSuccessGetNextStep, handleErrorGetNextStep);
    }
    renderBiometric() {
        // Tạo thẻ div
        const div = document.createElement('div');
        div.className = 'biometric-container ari-fixed ari-top-0 ari-left-0 ari-right-0 ari-bottom-0 ari-bg-white ari-z-[10000] ari-flex ari-justify-center';
        div.innerHTML = ` <div class="iframe-container ari-flex ari-justify-center ari-w-[90%]">
            <div id="loading" class="loading">Loading...</div>
            <iframe
                class=" ari-w-full"
                id="livenessIframe"
                title="Liveness Detection"
                src="${AriForm_1.AriForm.biometricLink}"
                allow="camera *; microphone *; autoplay *; clipboard-read; clipboard-write; geolocation; fullscreen *"
                style="visibility: hidden;"
            ></iframe>
        </div>`;
        document.body.appendChild(div);
        let iframeElement = null;
        let loadingElement = null;
        // Initialize when DOM is loaded
        iframeElement = document.getElementById('livenessIframe');
        loadingElement = document.getElementById('loading');
        const handleResult = (dataResult) => {
            var _a;
            if (dataResult && dataResult.message === "Success") {
                this.biometricData = dataResult;
                AriFormUtils.loadingFullScreen();
                this.doTask();
                window.removeEventListener('message', handleMessage);
                window.removeEventListener('error', handleError);
                window.removeEventListener('load', handleIframeLoad);
                div.remove();
            }
            else if (dataResult && dataResult.message !== "Success") {
                if ((_a = dataResult === null || dataResult === void 0 ? void 0 : dataResult.data) === null || _a === void 0 ? void 0 : _a.message) {
                    AriFormUtils.showPopup('error', 'Failed', dataResult.data.message);
                }
                window.removeEventListener('message', handleMessage);
                window.removeEventListener('error', handleError);
                window.removeEventListener('load', handleIframeLoad);
                div.remove();
            }
        };
        const handleMessage = (event) => {
            if (event.data === "getToken") {
                const parameters = {
                    username: AriForm_1.AriForm.biometricName,
                    password: AriForm_1.AriForm.biometricSecure,
                    retryTime: 3,
                    bioType: "face,nod,shake",
                    type: "getTokenResult",
                    language: AriFormUtils.getVariable("BlazorCulture") || "en_US"
                };
                // Delay sending parameters slightly
                setTimeout(() => {
                    if (iframeElement && iframeElement.contentWindow) {
                        iframeElement.contentWindow.postMessage(parameters, "*");
                    }
                }, 500); // 500ms delay
            }
            if (event.data.type === "bioResult") {
                handleResult(event.data);
            }
        };
        window.addEventListener('message', handleMessage);
        const handleIframeLoad = () => {
            // Hide loading indicator and show iframe
            if (loadingElement) {
                loadingElement.style.display = 'none';
            }
            if (iframeElement) {
                iframeElement.style.visibility = 'visible';
            }
        };
        iframeElement.addEventListener('load', handleIframeLoad);
        // Error handling
        const handleError = (event) => {
            console.error('Global error:', event.error);
        };
        window.addEventListener('error', handleError);
        // Handle iframe errors
        document.getElementById('livenessIframe').addEventListener('error', function () {
            if (loadingElement) {
                loadingElement.textContent = 'Failed to load. Please refresh the page.';
            }
        });
    }
    // end hungnq
    // LanLTH
    doTask() {
        var _a, _b;
        const form = this.getRoot();
        let dataset = {};
        let hasMissingSignature = false;
        const datamapping = form.formState.mappingData;
        AriFormUtils.eachComponent(form.schema.components, (component) => {
            if (component.type == "signature") {
                if (!form.getComponent(component.key).disabled) {
                    if (form.getComponent(component.key).getValue() == "") {
                        hasMissingSignature = true;
                    }
                }
            }
        });
        if (hasMissingSignature) {
            AriFormUtils.showPopup('error', 'Failed', `${AriFormUtils.getLangText("You must sign before submitting")}`);
            document.querySelector('.bpm-do-task-pdf').removeAttribute('disabled');
            this.clearInputOTP();
            return;
        }
        datamapping.map((v) => {
            var comp = form.getComponent(v.formField);
            if (comp && comp.getValue()) {
                switch (comp.type) {
                    case 'signature':
                        dataset[v.datasetField] = comp.getValue();
                        break;
                    default:
                        if (!comp.disabled)
                            dataset[v.datasetField] = comp.getValue();
                        break;
                }
            }
        });
        let payload = {};
        let authentication = {};
        let authenCode = null;
        payload['document'] = {
            formId: form.formState.formId,
            //submission: form.submission
        };
        if (form.formState.needAuthen) {
            this.authenType = ((_a = form.formState.custInfo) === null || _a === void 0 ? void 0 : _a.authenType) === 'OPTIONS' ? "SMSOTP" : ((_b = form.formState.custInfo) === null || _b === void 0 ? void 0 : _b.authenType) || this.otpInfo.authenType || 'SMSOTP';
            authenCode = this.authenType === "BIOMETRIC" ? this.biometricData.data.id : this.getFullOtpValue();
        }
        form.formState.needAuthen = form.formState.needAuthen === 'True' || form.formState.needAuthen === true ? true : false;
        if (!authenCode && form.formState.needAuthen && (form.formState.custInfo.authenType === "OTP" || form.formState.custInfo.authenType === "")) {
            AriFormUtils.showPopup('error', 'Failed', `${AriFormUtils.getLangText("Authentication Code is required")}`);
            document.querySelector('.bpm-do-task-pdf').removeAttribute('disabled');
            this.refs.button.disabled = false;
            return;
        }
        // if (!(form.formState.authenWhen && form.formState.authenWhen === 'view')) {
        authentication = {
            authenType: this.authenType,
            authenCode: authenCode,
            authenKey: this.authenType === "BIOMETRIC" ? form.formState.custInfo.cif : this.otpInfo.authenKey || ''
        };
        // }
        var body = {
            taskId: form.formState.taskId,
            activityId: form.formState.activityId,
            activityType: form.formState.activityType,
            authentication,
            dataset,
            payload,
        };
        AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointBpmESign}`, 'POST', body, {}, () => {
            // AriFormUtils.showPopup('success', `${AriFormUtils.getLangText("The task is complete.")}`, `${AriFormUtils.getLangText("Please review the activity and the next steps in the task history.")}`);
            const isNoAuthen = AriFormUtils.getVariableTemp('tokenAccess');
            if (!isNoAuthen) {
                this.callAPINextStep();
            }
            else {
                AriFormUtils.removeLoadingFullScreen();
                AriFormUtils.showPopup('success', `${AriFormUtils.getLangText("The task is complete.")}`, `${AriFormUtils.getLangText("Please review the activity and the next steps in the task history.")}`);
            }
            this.refs.button.disabled = true;
            if (this.bsModal) {
                this.bsModal.hide();
            }
        }, (error) => {
            AriFormUtils.removeLoadingFullScreen();
            AriFormUtils.showPopup('error', 'Failed', error.error.responseDesc || AriFormUtils.getLangText("Something went wrong"));
            document.querySelector('.bpm-do-task-pdf').removeAttribute('disabled');
            this.refs.button.disabled = false;
        });
    }
    // End LanLTH
    attach(element) {
        return super.attach(element).then(() => {
            this.loadRefs(element, {
                button: 'single',
                buttonPrint: 'single',
                buttonMessageContainer: 'single',
                buttonMessage: 'single',
                zoomIn: 'single',
                zoomOut: 'single',
                iframeContainer: 'single'
            });
            this.submitButton.refs = Object.assign({}, this.refs);
            this.submitButton.attachButton();
            // Reset the iframeReady promise.
            this.iframeReady = new Promise((resolve, reject) => {
                this.iframeReadyResolve = resolve;
                this.iframeReadyReject = reject;
            });
            // iframes cannot be in the template so manually create it
            this.iframeElement = this.ce('iframe', {
                src: this.getSrc(),
                id: `iframe-${this.id}`,
                seamless: true,
                class: 'ariform-iframe'
            });
            this.iframeElement.ariformContainer = this.component.components;
            this.iframeElement.ariformComponent = this;
            // Append the iframe to the iframeContainer in the template
            this.empty(this.refs.iframeContainer);
            this.appendChild(this.refs.iframeContainer, this.iframeElement);
            // Post the form to the iframe
            this.form.base = AriForm_1.AriForm.getBaseUrl();
            this.form.projectUrl = AriForm_1.AriForm.getProjectUrl();
            this.postMessage({ name: 'form', data: this.form });
            // Hide the submit button if the associated component is hidden
            const submitButton = this.components.find(c => c.element === this.refs.button);
            if (submitButton) {
                this.refs.button.classList.toggle('hidden', !submitButton.visible);
            }
            this.addEventListener(this.refs.buttonPrint, 'click', (event) => {
                event.preventDefault();
            });
            this.addEventListener(this.refs.zoomIn, 'click', (event) => {
                event.preventDefault();
                this.postMessage({ name: 'zoomIn' });
            });
            this.addEventListener(this.refs.zoomOut, 'click', (event) => {
                event.preventDefault();
                this.postMessage({ name: 'zoomOut' });
            });
            // hungnq 
            // this.addEventListener(this.refs.button, 'click', async (event) => {
            // const FormioExportModule = window["formio-export"];
            // const FormioExport = FormioExportModule.FormioExport;
            //   const form = this.getRoot();
            //   // ✅ phải dùng form.component (JSON gốc), không phải form.components
            //   const component = form.component;
            //   const submission = form.submission;
            //   // ✅ phải new class
            //   const exporter = new FormioExport(component, submission, {});
            //   // config xuất PDF
            //   const config = { filename: "example.pdf", download: true };
            //   exporter.toPdf(config).then((pdf) => {
            //     console.log("PDF ready", pdf);
            //   });
            // });
            this.addEventListener(this.refs.button, 'click', (event) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                const form = this.getRoot();
                // Không cần OTP → gọi task luôn
                if (!form.formState.needAuthen || form.formState.needAuthen === 'False') {
                    AriFormUtils.loadingFullScreen();
                    this.doTask();
                    return;
                }
                if (form.formState.custInfo.authenType === "BIOMETRIC") {
                    this.renderBiometric();
                    return;
                }
                if (this.countdownTime > 0) {
                    this.bsModal.show();
                }
                else {
                    //Xoá modal cũ nếu đang mở
                    if (this.bsModal) {
                        this.bsModal.hide();
                        this.bsModal = null;
                    }
                    //Xoá wrapper cũ nếu có
                    const oldWrapper = document.querySelector('.otp-wrapper');
                    if (oldWrapper) {
                        oldWrapper.remove();
                    }
                    // Tạo lại wrapper mới
                    const otpWrapper = document.createElement('div');
                    otpWrapper.className = 'otp-wrapper';
                    document.body.appendChild(otpWrapper);
                    const handleSendOTPSuccess = (result) => {
                        var _a, _b, _c, _d;
                        AriFormUtils.removeLoadingFullScreen();
                        this.otpInfo = result;
                        // Hiển thị modal
                        let modalEl = document.getElementById('otp-modal');
                        if (!modalEl) {
                            otpWrapper.innerHTML = this.renderOtpCode();
                            modalEl = document.getElementById('otp-modal');
                            this.bsModal = new window.bootstrap.Modal(modalEl);
                            this.bsModal.show();
                        }
                        else {
                            const countdownText = document.querySelector('.coundown-wraper .countdown-text');
                            if (countdownText)
                                countdownText.textContent = ''; // reset về trống trước
                            this.countdownEl.classList.remove('hidden');
                            document.querySelector('.wraper-resend-otp-btn').classList.add('d-none');
                            // 2. Reset lại các input
                            this.otpInputs.forEach(id => {
                                const input = document.getElementById(id);
                                if (input)
                                    input.value = '';
                            });
                        }
                        // Bắt đầu đếm ngược
                        this.countdownEl = otpWrapper.querySelector('.coundown-wraper');
                        this.countdownTime = result.otpExpiredTime * 60 || 0;
                        this.startCountdown();
                        // Gắn lại sự kiện submit (xóa cái cũ nếu có)
                        if (this.handleClickSubmit) {
                            (_a = document.querySelector('.bpm-do-task-pdf')) === null || _a === void 0 ? void 0 : _a.removeEventListener('click', this.handleClickSubmit);
                        }
                        if (this.hanldeclickCloseOTP) {
                            (_b = document.querySelector('.close-modal-otp')) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', this.hanldeclickCloseOTP);
                        }
                        this.hanldeclickCloseOTP = () => {
                            if (this.bsModal) {
                                this.bsModal.hide();
                                this.clearInputOTP();
                                this.checkOtpComplete();
                            }
                        };
                        this.handleClickSubmit = () => {
                            document.querySelector('.bpm-do-task-pdf').setAttribute('disabled', true);
                            AriFormUtils.loadingFullScreen();
                            this.doTask();
                        };
                        (_c = document.querySelector('.close-modal-otp')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', this.hanldeclickCloseOTP);
                        (_d = document.querySelector('.bpm-do-task-pdf')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', this.handleClickSubmit);
                        // Gắn lại OTP input và resend (gỡ cái cũ nếu cần)
                        this.initOtpInputs();
                        // Gắn resend OTP chỉ 1 lần (đảm bảo không lặp lại)
                        const resendBtn = document.querySelector('.resend-otp-btn');
                        if (resendBtn) {
                            if (this.resendClickHandler) {
                                resendBtn.removeEventListener('click', this.resendClickHandler);
                            }
                            this.resendClickHandler = () => {
                                sendOTP();
                            };
                            resendBtn.addEventListener('click', this.resendClickHandler);
                        }
                        this.checkOtpComplete();
                    };
                    const handleError = (message) => {
                        AriFormUtils.removeLoadingFullScreen();
                        AriFormUtils.showPopup('error', 'Failed', message || AriFormUtils.getLangText("'Something went wrong'"));
                        this.refs.button.disabled = false;
                    };
                    const sendOTP = () => {
                        let custInfo = AriFormUtils.getVariable('custInfo') ? JSON.parse(AriFormUtils.getVariable('custInfo')) : {};
                        const apiBody = {
                            taskId: form.formState.taskId || '',
                            activityId: form.formState.activityId || '',
                            cif: AriFormUtils.getParamUrl('cif', '', true) || custInfo.cif || '',
                            licenseNo: AriFormUtils.getParamUrl('licenseNo', '', true) || custInfo.licenseNo || '',
                        };
                        AriFormUtils.loadingFullScreen();
                        AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.endpointBpmSendOTP}`, 'POST', apiBody, {}, handleSendOTPSuccess, handleError);
                    };
                    // Gọi lần đầu
                    sendOTP();
                }
            }));
            // end hungnq
            const form = (0, utils_1.fastCloneDeep)(this.form);
            if (this.ariform) {
                form.projectUrl = this.ariform.projectUrl;
                form.url = this.ariform.formUrl;
                form.base = this.ariform.base;
                this.postMessage({ name: 'token', data: this.ariform.getToken() });
            }
            this.emit('attach');
        });
    }
    /**
     * Get the submission from the iframe.
     * @returns {Promise<any>} - The submission from the iframe.
     */
    getSubmission() {
        return new Promise((resolve) => {
            this.once('iframe-submission', resolve);
            this.postMessage({ name: 'getSubmission' });
        });
    }
    /**
     * Ensure we have the submission from the iframe before we submit the form.
     * @param {any} options - The options for submission.
     * @returns {Promise<any>} - Resolves when the form is submitted.
     */
    submitForm(options = {}) {
        this.postMessage({ name: 'getErrors' });
        return this.getSubmission().then(() => super.submitForm(options));
    }
    getSrc() {
        if (!this._form || !this._form.settings || !this._form.settings.pdf) {
            return '';
        }
        let iframeSrc = `${this._form.settings.pdf.src}.html`;
        const params = [`id=${this.id}`];
        if (this.options.showCheckboxBackground || this._form.settings.showCheckboxBackground) {
            params.push('checkboxbackground=1');
        }
        if (this.options.readOnly) {
            params.push('readonly=1');
        }
        if (this.options.zoom) {
            params.push(`zoom=${this.options.zoom}`);
        }
        if (this.builderMode) {
            params.push('builder=1');
        }
        if (params.length) {
            iframeSrc += `?${params.join('&')}`;
        }
        return iframeSrc;
    }
    setForm(form, flags = {}) {
        return super.setForm(form, flags).then(() => {
            if (this.ariform) {
                form.projectUrl = this.ariform.projectUrl;
                form.url = this.ariform.formUrl;
                form.base = this.ariform.base;
                this.postMessage({ name: 'token', data: this.ariform.getToken() });
            }
            this.postMessage({ name: 'form', data: this.form });
        });
    }
    /**
     * Set's the value of this form component.
     * @param {import('@ariform/core').Submission} submission - The submission JSON to set the value of this form.
     * @param {any} flags - The flags to use when setting the submission.
     * @returns {boolean} - If the value changed or not.
     */
    setValue(submission, flags = {}) {
        const changed = super.setValue(submission, flags);
        if (!flags || !flags.fromIframe) {
            this.once('iframe-ready', () => {
                if (changed) {
                    this.postMessage({ name: 'submission', data: submission });
                }
            });
        }
        return changed;
    }
    postMessage(message) {
        // If we get here before the iframeReady promise is set up, it's via the superclass constructor
        if (!this.iframeReady) {
            return;
        }
        if (!message.type) {
            message.type = 'iframe-data';
        }
        this.iframeReady.then(() => {
            if (this.iframeElement && this.iframeElement.contentWindow && !(message.name === 'form' && this.iframeFormSetUp)) {
                this.iframeElement.contentWindow.postMessage(JSON.stringify(message), '*');
                this.iframeFormSetUp = message.name === 'form';
            }
        });
    }
    focusOnComponent(key) {
        this.postMessage({
            name: 'focusErroredField',
            data: key,
        });
    }
    // Do not clear the iframe.
    clear() { }
    showErrors(error, triggerEvent) {
        var _a;
        const helpBlock = document.getElementById('submit-error');
        const submitError = this.t('submitError');
        const isSubmitErrorShown = ((_a = this.refs.buttonMessage) === null || _a === void 0 ? void 0 : _a.textContent.trim()) === submitError;
        if (!helpBlock && error.length && !isSubmitErrorShown) {
            const p = this.ce('p', { class: 'help-block' });
            this.setContent(p, submitError);
            p.addEventListener('click', () => {
                window.scrollTo(0, 0);
            });
            const div = this.ce('div', { id: 'submit-error', class: 'has-error' });
            this.appendTo(p, div);
            this.appendTo(div, this.element);
        }
        if (!error.length && helpBlock) {
            helpBlock.remove();
        }
        super.showErrors(error, triggerEvent);
    }
    isSubmitButtonHidden() {
        let hidden = false;
        (0, utils_1.eachComponent)(this.component.components, (component) => {
            if ((component.type === 'button') &&
                ((component.action === 'submit') || !component.action)) {
                hidden = component.hidden || false;
            }
        });
        return hidden;
    }
}
exports.default = PDF;
/**
 * Listen for window messages.
 */
if (typeof window !== 'undefined') {
    window.addEventListener('message', (event) => {
        let eventData = null;
        try {
            eventData = JSON.parse(event.data);
        }
        catch (err) {
            eventData = null;
        }
        // If this form exists, then emit the event within this form.
        if (eventData &&
            eventData.name &&
            eventData.formId &&
            AriForm_1.AriForm.forms.hasOwnProperty(eventData.formId)) {
            AriForm_1.AriForm.forms[eventData.formId].emit(`iframe-${eventData.name}`, eventData.data);
        }
    });
}
